import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import {SortableContainer, SortableElement, arrayMove, SortableHandle} from 'react-sortable-hoc';
import shortid from 'shortid';

import { pmUpdateFromHybrid, showTooltip, hideTooltip } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'

import './FormEditor.css';

var updateTimeout;

class FormEditor extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  // I love you 
  constructor(props){
    super(props);

    this.state = {
      showField: {
        row: -1,
        cell: -1
      },
      page_size: 15,
      page: 0
    }

    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.addRow = this.addRow.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.cloneRow = this.cloneRow.bind(this);
    this.recolor = this.recolor.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleShowToolTip = this.handleShowToolTip.bind(this);
    this.handleHideToolTip = this.handleHideToolTip.bind(this);
    this.handleShowField = this.handleShowField.bind(this);
  }

  handleFieldChange(i, j, value){
    
    const { dispatch, patternManager, cacheID } = this.props;
    var rows = JSON.parse(JSON.stringify(patternManager.cache[cacheID].rows));
    rows[i].cells[j] = value;

    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(function(){
      dispatch(pmUpdateFromHybrid({
        cacheID: cacheID,
        pattern: {
          rows: rows
        },
        regenText: true
      }))
    }, 400);
  }

  addRow(e, dashed){
    const { dispatch, patternManager, cacheID } = this.props;
    var rows = JSON.parse(JSON.stringify(patternManager.cache[cacheID].rows));

    var offset = patternManager.cache[cacheID].units === 'INCH' ? 1 : 10;
    var line = dashed ? offset : 0;
    var space = dashed ? -offset: 0

    var cells;

    switch(e.value){
      case 'Horizontal':
        cells = [0, 0, 0, offset, 0, line, space];
        break;
      case 'Vertical':
        cells = [90, 0, 0, offset, 0, line, space];
        break;
      case '45°':
        cells = [45, 0, 0, offset, 0, line, space];
        break;
      case '30°':
        cells = [30, 0, 0, offset, 0, line, space];
        break;
      case '60°':
        cells = [60, 0, 0, offset, 0, line, space];
        break;
      default: 
        return;
    }
  
    rows.push({original_index: calculateIndex(rows), cells: cells});

    dispatch(pmUpdateFromHybrid({
      cacheID: cacheID,
      pattern: {
        rows: rows
      },
      regenText: true
    }));
  }

  deleteRow(i){
    const { dispatch, patternManager, cacheID } = this.props;
    var rows = JSON.parse(JSON.stringify(patternManager.cache[cacheID].rows));
    rows.splice(i, 1);

    dispatch(pmUpdateFromHybrid({
      cacheID: cacheID,
      pattern: {
        rows: rows
      },
      regenText: true
    }))
  }

  cloneRow(i){
    const { dispatch, patternManager, cacheID } = this.props;
    var rows = JSON.parse(JSON.stringify(patternManager.cache[cacheID].rows));
    var nr = JSON.parse(JSON.stringify(rows[i]));
    nr.original_index = calculateIndex(rows);
    rows.splice(parseInt(i, 10) + 1, 0, nr);

    dispatch(pmUpdateFromHybrid({
      cacheID: cacheID,
      pattern: {
        rows: rows
      },
      regenText: true
    }))
  }

  toggle(i, val){
    const { dispatch, patternManager, cacheID } = this.props;
    
    var rows = JSON.parse(JSON.stringify(patternManager.cache[cacheID].rows));

    i = parseInt(i, 10);
    var r;

    if(i === -1){
      var falseAlreadyCounter = 0;
      for(r in rows){
        if(!rows[r][val]) falseAlreadyCounter++;
        rows[r][val] = false;
      }
      if(falseAlreadyCounter === rows.length){
        for(r in rows){
          rows[r][val] = true;
        }
      }
    } else {
      if(rows[i][val] === undefined){
        rows[i][val] = true;
      } else {
        rows[i][val] = !rows[i][val];
      }
    }

    dispatch(pmUpdateFromHybrid({
      cacheID: cacheID,
      pattern: {
        rows: rows
      }
    }))
  }

  handleShowField(r,c){
    console.log('showField',r,c);
    this.setState({
      showField: {
        row: r,
        cell: c
      }
    });
  }

  handleShowToolTip(data){
    const { dispatch } = this.props;
    dispatch(showTooltip(data));
  }

  handleHideToolTip(){
    const { dispatch } = this.props;
    dispatch(hideTooltip());
  }

  recolor(){
    const { dispatch, patternManager, cacheID } = this.props;

    var rows = JSON.parse(JSON.stringify(patternManager.cache[cacheID].rows));

    for(var i in rows){
      rows[i].original_index = parseInt(i, 10);
    }

     dispatch(pmUpdateFromHybrid({
      cacheID: cacheID,
      pattern: {
        rows: rows,
      }
    }))
  } 

  onSortEnd = ({oldIndex, newIndex}) => {
    const {dispatch, patternManager, cacheID} = this.props;
  
    dispatch(pmUpdateFromHybrid({
      cacheID: cacheID,
      pattern: {
        rows: arrayMove(patternManager.cache[cacheID].rows, oldIndex, newIndex)
      },
      regenText: true
    }))  
  };

  render(){
    const { patternManager, dispatch, cacheID } = this.props; 
    var pattern = patternManager.cache[cacheID];
    var numberOfRows = pattern.rows.length;

    var maxRowDash = [0];
    for(var i in pattern.rows){
      var l = (pattern.rows[i].cells.length - 5) / 2;
      while(l > maxRowDash.length) maxRowDash.push(maxRowDash.length);
    }

    if(pattern.format === 'AUTOCAD' && maxRowDash.length > 3){
      maxRowDash = [0,1,2];
    }

    return (
      <div className="form-editor-wrapper">
        <div className="new-hybrid-form">
          <div className="new-hybrid-dock new-hybrid-dock-top">
            <div className="new-hybrid-header">
              <span className="invisible"><DragHandle/></span>
              <div className="new-hybrid-alphakey-field new-hybrid-field-spacer">
                <span onClick={this.recolor} className="clickable clickable-text new-hybrid-header-btn"><i className="fas fa-fw fa-palette"/></span>
              </div>
              <div className="new-hybrid-field">Angle</div>
              <div className="new-hybrid-field">X</div>
              <div className="new-hybrid-field">Y</div>
              <div className="new-hybrid-field">Shift</div>
              <div className="new-hybrid-field">Offset</div> 
              {
                maxRowDash.map(function(p, i){
                  return <div key={i} className="inline">
                    {
                      i == 0 ? 
                      <div className="new-hybrid-field new-hybrid-field-2x">DASH SEQUENCE</div>
                      :
                      <div className={"new-hybrid-field new-hybrid-field-2x"}></div>
                    }
                  </div>
                })
              }
              <div className="new-hybrid-mini-btn-field">
                <span onClick={(e)=> {this.toggle(-1,'invisible') }} className="clickable clickable-text new-hybrid-header-btn"><i className="far fa-fw fa-eye"/></span>
              </div>
              <div className="new-hybrid-mini-btn-field">
                <span onClick={(e)=> {this.toggle(-1,'greyscale') }} className="clickable clickable-text new-hybrid-header-btn"><i className="far fa-fw fa-tint"/></span>
              </div>
              <div className="new-hybrid-mini-btn-field">
                <span onClick={(e)=> {this.toggle(-1,'bold') }} className="clickable clickable-text new-hybrid-header-btn"><i className="fal fa-fw fa-bold"/></span>
              </div>
            </div>
          </div>
          <div className="new-hybrid-divider"></div>
          <div className="new-hybrid-form-table">
            <SortableList 
              items={pattern.rows} 
              onSortEnd={this.onSortEnd} 
              useDragHandle={true} 
              numberOfRows={numberOfRows} 
              pat={pattern} 
              handleFieldChange={this.handleFieldChange} 
              deleteRow={this.deleteRow} 
              cloneRow={this.cloneRow} 
              toggle={this.toggle}
              maxRowDash={maxRowDash}
              handleShowToolTip={this.handleShowToolTip}
              handleHideToolTip={this.handleHideToolTip}
              handleShowField={this.handleShowField}
              currentShowField={this.state.showField}
              page={this.state.page}
              page_size={this.state.page_size}
            />
          </div>
          
          {
            Math.ceil(pattern.rows.length / this.state.page_size) > 1 && <div className="list-right new-hybrid-pagination-bar">  
              <small className="translucent">
                Showing rows {this.state.page_size * this.state.page + 1} through {
                  pattern.rows.length > this.state.page_size * (this.state.page + 1) ? 
                  this.state.page_size * (this.state.page + 1)
                  :
                  pattern.rows.length
                }
              </small>
              <Button
                size="thin" 
                display={<span><i className="fas fa-lg fa-fw fa-angle-left"/> Previous</span>} 
                color="transparent" 
                onClick={(e)=>{ this.setState({
                  page: this.state.page - 1
                }) }}
                disabled={this.state.page === 0}
                />
              <Button
                size="thin" 
                display={<span>Next <i className="fas fa-lg fa-fw fa-angle-right"/></span>} 
                color="transparent" 
                onClick={(e)=>{ this.setState({
                  page: this.state.page + 1
                }) }}
                disabled={this.state.page * this.state.page_size >= pattern.rows.length}
                />
            </div>
          }
        </div>
      </div>
    )
  }
}

const calculateIndex = function(rows){
  var oiList = rows.map(function(r){ return r.original_index});
  oiList.sort(function(a, b){
    if(a > b) return 1;
    if(b > a) return -1;
    return 0;
  });

  var oi = 0;
  for(var i in oiList){
    if(oiList[i] === oi){
      oi++;
    } else {
      break;
    }
  }
  return oi;
}

const calculateStep = function(units, value){
  if(units === 'MM') return 1;
  value = Math.abs(value);
  if(value >= 24) return 1;
  if(value >= 12) return 1/2;
  if(value >= 6) return 1/4;
  if(value >= 3) return 1/8;
  return 1/16;
}


const revitValueRangeCheck = function(pat, c){
  c = Math.abs(c);
  if(pat.type === 'MODEL'){
    if(pat.units === 'INCH'){
      if(c < 0.5 || c > 848.5){
        return true;
      }
    } else {
      if(c < 12.7 || c > 21552){
        return true;
      }
    }
  } else {
    if(pat.units === 'INCH'){
      if(c < 0.002 || c > 84.85){
        return true;
      }
    } else {
      if(c < 0.051 || c > 2155){
        return true;
      }
    }
  }
  return false;
} 

const generateOffsetErrorDescription = function(pat){
  if(pat.type === 'MODEL'){
    if(pat.units === 'INCH'){
      return "Offset must be between 0.5 and 848.5 for INCH based MODEL patterns for Revit."
    } else {
      return "Offset must be between 12.7 and 21552 for MM based MODEL patterns for Revit."
    }
  } else {
    if(pat.units === 'INCH'){
      return "Offset must be between 0.002 and 84.85 for INCH based DRAFTING patterns for Revit."
    } else {
      return "Offset must be between 0.051 and 2155 for MM based DRAFTING patterns for Revit."
    }
  }
  return false;
}
const generateLineSpaceErrorDescription = function(pat){
  if(pat.type === 'MODEL'){
    if(pat.units === 'INCH'){
      return "The absolute sum of all LINE and SPACE fields must be between 0.5 and 848.5 for INCH based MODEL patterns for Revit."
    } else {
      return "The absolute sum of all LINE and SPACE fields must be between 12.7 and 21552 for MM based MODEL patterns for Revit."
    }
  } else {
    if(pat.units === 'INCH'){
      return "The absolute sum of all LINE and SPACE fields must be between 0.002 and 84.85 for INCH based DRAFTING patterns for Revit."
    } else {
      return "The absolute sum of all LINE and SPACE fields must be between 0.051 and 2155 for MM based DRAFTING patterns for Revit."
    }
  }
  return false;
}

const DragHandle = SortableHandle(() => <span className="drag-handle"><i className="fal fa-grip-vertical fa-lg draggable"/></span>); // This can be any component you want

const SortableItem = SortableElement(({value, index, i, numberOfRows, pat, handleFieldChange, deleteRow, cloneRow, toggle, maxRowDash, handleShowToolTip, handleHideToolTip, handleShowField, currentShowField}) => {

  const getLetterKey = function(oi){
    const alpha = 'abcdefghijklmnopqrstuvwxyz'.toUpperCase();

    const v = (Math.floor(oi / alpha.length) + 1) + "";
    
    if(pat.rows.length > alpha.length) return alpha[oi % alpha.length] + v; 
    return alpha[oi];
  }

  const color_class = "bg_" + ((parseInt(value.original_index, 10) * 3) % 11);

  var dashTotal = 0;
  var count = 0;
  var dashError = false;
  var dashErrorDescription = ""
  for(var k = 5; k < value.cells.length; k++){
    dashTotal += Math.abs(parseFloat(value.cells[k]));
    count++;
  }
  
  if(revitValueRangeCheck(pat, dashTotal) && count > 0){
    dashError = true;
    dashErrorDescription = generateLineSpaceErrorDescription(pat);
  }

  var cells = JSON.parse(JSON.stringify(value.cells));
  while(cells.length < 7){
    cells.push('');
  }

  return <li className="new-hybrid-table-li">
    <nobr>
      <span className="draggable"><DragHandle/></span>
      <div className={"new-hybrid-field-spacer new-hybrid-alphakey-field new-hybrid-color-bg " + color_class}>
        <span className={"new-hybrid-alphakey "}>
          <span className="new-hybrid-alphakey-letter">{getLetterKey(value.original_index)}</span>
        </span>
      </div>
      {
        cells.map(function(c, j){
          if(pat.format === 'AUTOCAD' && j > 10) return '';

          var errClass = "";
          var errorDescription = ""
          if(pat.format === 'REVIT'){
            if(j == 4){
              if(revitValueRangeCheck(pat, c)){
                errClass = " new-hybrid-field-error ";
                errorDescription = generateOffsetErrorDescription(pat);
              }
            } else if(j > 4 && dashError){
              errClass = " new-hybrid-field-error ";
              errorDescription = dashErrorDescription;
            }
          }

          return <span 
            className={"new-hybrid-field " + errClass} 
            key={'cell_' + i + '_' + j}
            onClick={(e)=>{
              if(currentShowField.row !== i && currentShowField.cell !== j){
                handleShowField(i,j);
              }
            }}
            onMouseEnter={(e)=>{ 
              if(errorDescription){
                handleShowToolTip({
                  e: e, 
                  content: <div style={{width: 150}} className="text-danger">{errorDescription}</div>, 
                  position: 'top', 
                  nobr: false
                }) 
              }
            }}
            onMouseLeave={(e)=>{
              if(currentShowField.row === i && currentShowField.cell === j){
                handleShowField(-1,-1);
              }
              if(errorDescription){
                handleHideToolTip();
              }
            }}>
            {
              (currentShowField.row === i && currentShowField.cell === j) ?
              <Field 
                name={'rows[' + i + '].cells[' + j + ']'} 
                step={(j === 0 ? 1 : calculateStep(pat.units, c))} 
                component="input" 
                type="number" 
                max={( (j >= 4 && j - 4 % 2 === 0) ? 0 : undefined)}
                onChange={(e) => { handleFieldChange(i,j,e.target.value)}}
              />
              :
              <span className="form-editor-fake-field">{c}</span>
            }
            <span style={{display: 'none'}}>{c}</span>
          </span>
        })
      }
      
      <div className="new-hybrid-mini-btn-field">
        <span onClick={(e) => {toggle(i, 'invisible')}} className={"mini mini-btn " + (value.invisible ? 'mini-btn-on' : 'mini-btn-off')} key={'a_' + shortid.generate()}>
          <span className="fa-stack fa-2x">
            <i className="fas fa-circle fa-stack-2x"></i>
            <i className={"far fa-stack-1x faDark " + (value.invisible ? "fa-eye-slash" : "fa-eye")}></i>
          </span>
        </span>
      </div>
      <div className="new-hybrid-mini-btn-field">
        <span onClick={(e) => {toggle(i, 'greyscale')}} className={"mini mini-btn " + (value.greyscale ? 'mini-btn-on' : 'mini-btn-off')} key={'a_' + shortid.generate()}>
          <span className="fa-stack fa-2x">
            <i className="fas fa-circle fa-stack-2x"></i>
            <i className={"far fa-stack-1x faDark " + (value.greyscale ? "fa-tint-slash" : "fa-tint")}></i>
          </span>
        </span>
      </div>
      <div className="new-hybrid-mini-btn-field">
        <span onClick={(e) => {toggle(i, 'bold')}} className={"mini mini-btn " + (value.bold ? 'mini-btn-on' : 'mini-btn-off')} key={'a_' + shortid.generate()}>
          <span className="fa-stack fa-2x">
            <i className="fas fa-circle fa-stack-2x"></i>
            <i className={"fa-stack-1x faDark " + (value.bold ? "fas fa-bold" : "fal fa-bold")}></i>
          </span>
        </span>
      </div>
      
      <span className="mini-btn-divider">|</span>

      <div className="new-hybrid-mini-btn-field">
        <span onClick={(e) => {cloneRow(i)}} className="mini mini-btn">
          <span className="fa-stack fa-2x">
            <i className="fas fa-circle fa-stack-2x"></i>
            <i className="far fa-clone fa-stack-1x faDark"></i>
          </span>
        </span>
      </div>
      <div className="new-hybrid-mini-btn-field">
        <span onClick={(e) => {deleteRow(i)}} className="mini mini-btn">
          <span className="fa-stack fa-2x">
            <i className="fas fa-circle fa-stack-2x"></i>
            <i className="fas fa-times fa-stack-1x faDark"></i>
          </span>
        </span>
      </div>
    </nobr>
  </li>

})

const SortableList = SortableContainer(({items, numberOfRows, pat, handleFieldChange, deleteRow, cloneRow, toggle, maxRowDash, handleShowToolTip, handleHideToolTip, handleShowField, currentShowField, page, page_size}) => {

  var current_items_on_page = [];

  for(var i = page * page_size; (i < items.length && i < (page + 1) * page_size); i++){
    current_items_on_page.push(items[i]);
  }

  return (
    <ul className="list-unstyled new-hybrid-list">
      {current_items_on_page.map((value, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          i={index}
          numberOfRows={numberOfRows}
          value={value}
          pat={pat}
          handleFieldChange={handleFieldChange}
          deleteRow={deleteRow}
          cloneRow={cloneRow}
          toggle={toggle}
          maxRowDash={maxRowDash}
          handleShowToolTip={handleShowToolTip}
          handleHideToolTip={handleHideToolTip}
          handleShowField={handleShowField}
          currentShowField={currentShowField}
        />
      ))}
    </ul>
  );
});


FormEditor = reduxForm({
  // a unique name for the form
  form: 'FormEditor',
  enableReinitialize: true,
  destroyOnUnmount: false
})(FormEditor)

FormEditor = connect((state, ownProps) => {
  const { patternManager } = state;

  var initialValues = {
    name: patternManager.cache[ownProps.cacheID].name,
    type: patternManager.cache[ownProps.cacheID].type,
    units: patternManager.cache[ownProps.cacheID].units,
    rows: patternManager.cache[ownProps.cacheID].rows,
    scale_factor: patternManager.cache[ownProps.cacheID].scale_factor
  };
  

  return {
    patternManager,
    initialValues,
    state
  }
})(FormEditor);


export default FormEditor;


// WEBPACK FOOTER //
// ./src/components/FormEditor/FormEditor.js